<template lang="pug">
.review-import.primary--text
  .d-flex.mt-6(v-if="!errorItems.length")
    v-icon(color="success" size=28) $yzi-check-circle-solid
    .ml-4
      .mb-1.text-lg.font-semibold {{ $t('csv_import_success_title') }}
      div {{ $t('csv_import_success_description') }}

  div(v-else)
    .d-flex.mt-6.mb-4
      .mr-2
        .mb-2.text-md.font-semibold {{ $t('csv_import_error_title') }}
        span.font-bold {{ errorItems.length }} 
        span {{ $t('csv_import_error_description', { count: errorItems.length > 1 }) }}
        .d-flex.mt-4
          yc-checkbox.mr-3(v-model="ignoreErrors")
          .text-sm {{ $t('ignore_and_remove_all_rows_data') }}
      v-btn.button-sm(@click="reuploadCsv" outlined depressed) {{ $t('reupload_csv') }}

    template(v-if="!ignoreErrors")
      v-data-table(:headers="headers" :items="errorItems" :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" hide-default-footer disable-sort :mobile-breakpoint="0" height="240")
      .d-flex.align-center
        v-spacer
        yc-pagination-custom(v-model="page" :parentPageSize.sync="itemsPerPage" :count="errorItems.length" attach text="Item list")

  .text-right.mt-8
    v-btn.button-md(@click="finish" color="primary" depressed :loading="isLoading" :disabled="disableFinish") {{ $t('finish') }}
  
  .dialogs
    y-dialog(v-if="showConfirmationDialog" v-model="showConfirmationDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          .text-xl.font-medium.mb-4 All of the contact with error will be discarded and not imported
          .text-md {{ $t('click_confirm_to_proceed') }}
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-md(@click="showConfirmationDialog = false" text) {{ $t('cancel') }}
          v-btn.button-md(@click="confirm" color="danger" depressed dark) {{ $t('confirm') }}
    
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['data', 'inputFile', 'mapperFormData', 'title', 'description'],
  data: () => ({
    selectedItem: null,
    page: 1,
    pageCount: 0,
    itemsPerPage: 100,
    showFixDialog: false,
    showConfirmationDialog: false,
    selectedFixOption: null,
    isLoading: false,
    headers: [
      { text: 'Error Description', value: 'error' },
    ],
    ignoreErrors: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    errorItems () {
      const errors = []
      this.data?.errors.forEach(item => {
        errors.push({ error: item })
      })
      return errors
    },
    disableFinish () {
      if (this.ignoreErrors) {
        return false
      } else if (this.errorItems.length > 0) {
        return true
      }
      return false
    }
  },
  created () {
    this.headers.map(item => {
      item.class = 'text-table-header'
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    finish () { 
      if (this.errorItems.length) {
        this.showConfirmationDialog = true
        return
      }
      this.processCsv()
    },
    confirm () {
      this.showConfirmationDialog = false
      this.processCsv()
    },
    processCsv () {
      this.isLoading = true
      const form = this.mapperFormData
      this.$axios.post(`/reviews/${this.company.slug}/invites/process_csv`, form)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.csv_imported_successfully')])
          this.$emit('onComplete')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
          this.isLoading = false
        })
    },
    reuploadCsv () {
      this.$emit('onReupload')
    }
  }
}
</script>
